import React from 'react'

function QuizLesson({currentLesson}) {
  return (
    <div>QuizLesson is comming soon</div>
  )
}

export default QuizLesson
